import React, { useEffect, useState } from "react";
import { Calendar, ArrowRight } from "lucide-react";

export default function FloatingBookCTA({ href = "#book", label = "Book a Call" }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href={href}
      data-testid="floating-book-cta"
      className={`fixed bottom-5 right-5 z-[60] pill inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-[var(--terracotta)] text-[var(--cream)] font-medium transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      style={{ boxShadow: "0 14px 32px -10px rgba(184, 71, 45, 0.55)" }}
    >
      <Calendar className="w-4 h-4" />
      <span>{label}</span>
      <ArrowRight className="w-4 h-4" />
    </a>
  );
}
